require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-feisty-resumes.json") })
        }
      }, "path---projects-feisty-resumes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-feisty-resumes!./.cache/json/projects-feisty-resumes.json
// module id = 520
// module chunks = 231608221292675